import { InfoIcon, CheckIcon, AlertDiamondIcon, AlertTriangleIcon, XIcon } from '@shopify/polaris-icons';
import { Button, Icon } from '@shopify/polaris';
import './Toast.css';

const STATUS_STYLES = {
    error: 'toast-banner-icon-error',
    success: 'toast-banner-icon-success',
    warning: 'toast-banner-icon-warning',
    info: 'toast-banner-icon-info',
};

const ICONS = {
    error: AlertDiamondIcon,
    success: CheckIcon,
    warning: AlertTriangleIcon,
    info: InfoIcon,
};

function getBannerClassName(status) {
    return ['toast-banner-icon', STATUS_STYLES[status] || STATUS_STYLES.info].join(' ');
}

const ToastBanner = ({ status = 'info', children, onDismiss }) => (
    <div className={`toast-banner toast-banner-${status}`} role="alert" aria-live="polite">
        <div className="toast-banner-content">
            <div className={getBannerClassName(status)}>
                <Icon source={ICONS[status] || ICONS.info} />
            </div>
            <div>{children}</div>
        </div>
        {onDismiss && <Button variant="tertiary" icon={XIcon} onClick={onDismiss} aria-label="Dismiss" />}
    </div>
);

export default ToastBanner;
